export const wrapVariable = (input: unknown): string => `\${${input}}`

export const wrapVariables = (
  inputs: Record<string, unknown>
): Record<string, string> => {
  return Object.entries(inputs).reduce(
    (acc, [key, value]) => ({ ...acc, [key]: wrapVariable(value) }),
    {}
  )
}
